import { createSelector } from 'reselect';
/**
 * Simple selector to extract cartLookup selected bank object from the sell transaction.
 * @param state
 * @returns {Bank|null} Currently selected bank
 */
export const getEligibleAgreements = (state) =>
  state.eligibleAgreements.agreementsEligibilityList.eligibleAgreements || [];

export const hasEligibilitySucceed = (state) =>
  state.eligibleAgreements.eligibilitySuccess;

export const getIneligibleAgreements = (state) =>
  state.eligibleAgreements.agreementsEligibilityList.ineligibleAgreements || [];

export const getEligibleAgreementsCount = createSelector(
  getEligibleAgreements,
  (eligibleAgreements) => {
    return eligibleAgreements ? eligibleAgreements.length : 0;
  }
);

export const getIneligibleAgreementsCount = createSelector(
  getIneligibleAgreements,
  (ineligibleAgreements) => {
    return ineligibleAgreements ? ineligibleAgreements.length : 0;
  }
);

export const hasIneligibleAgreements = createSelector(
  getEligibleAgreementsCount,
  getIneligibleAgreementsCount,
  (eligibleAgreements, ineligibleAgreements) => {
    return eligibleAgreements.length === 0 && ineligibleAgreements > 0;
  }
);
